import React, { FC, useState } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import { NavbarVariantEnum } from 'src/types';
import { StyledNavBarIcon } from '../BaseNavbar.styles';
import { StyledLink, StyledText, StyledTooltip } from './NavLink.styles';

interface Props {
  'data-testid'?: string;
  to: string;
  text: string;
  icon?: string | React.ReactNode;
  navOpen?: boolean;
  tooltipText?: string;
  variant?:
    | NavbarVariantEnum.REPORTER
    | NavbarVariantEnum.MANAGER
    | NavbarVariantEnum.PUBLIC;
  onClick?: () => void;
}

export const NavLink: FC<Props> = ({
  to,
  text,
  icon,
  navOpen = true,
  tooltipText,
  variant = NavbarVariantEnum.MANAGER,
  ...props
}) => {
  const [navTooltip, setNavTooltip] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [navTooltipRoot, setNavTooltipRoot] = useState<any>(null);
  const location = useLocation();
  const route = location.pathname;

  const isCustomIcon = React.isValidElement(icon);

  return (
    <>
      <li>
        <StyledLink
          data-testid={props['data-testid']}
          variant={variant}
          to={to}
          state={{ fromNavbar: true }}
          $isActive={route === to}
          onClick={props.onClick}
        >
          {icon && (
            <span
              ref={setNavTooltipRoot}
              onMouseOver={() => setNavTooltip(true)}
              onMouseOut={() => setNavTooltip(false)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              {isCustomIcon ? (
                icon
              ) : (
                <StyledNavBarIcon className={icon as string} size="20px" />
              )}
            </span>
          )}
          <StyledText $navOpen={navOpen}>{text}</StyledText>
        </StyledLink>
      </li>
      {navTooltip && tooltipText && !navOpen && (
        <StyledTooltip
          text={tooltipText}
          variant="left"
          root={navTooltipRoot}
        />
      )}
    </>
  );
};
